'use strict';

import Axios from "axios";
import AuthCheck from '../Auth';

export default class Api {

    static get url() {
        return process.env.VUE_APP_API_URL + '/v2/';
    }

    static get urlV1() {
        return process.env.VUE_APP_API_URL + '/v1/';
    }

    static getAxios() {
        const token = AuthCheck.getToken();
        let headers = {
            'Content-Type': 'multipart/form-data',
        };
        if (token) {
            headers['Authorization'] = 'Bearer '.concat(token);
        }
        return Axios.create({
            headers: headers,
        });
    }
    getUrl(route) {
        return Api.url + route;
    }
    static getUrl(route) {
        return Api.url + route;
    }

    getUrlV1(route) {
        return Api.urlV1 + route;
    }
    static getUrlV1(route) {
        return Api.urlV1 + route;
    }

}
